import { render } from "./PortfolioItem.vue?vue&type=template&id=06533bd9&scoped=true&ts=true"
import script from "./PortfolioItem.vue?vue&type=script&lang=ts"
export * from "./PortfolioItem.vue?vue&type=script&lang=ts"

import "./PortfolioItem.vue?vue&type=style&index=0&id=06533bd9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06533bd9"]])

export default __exports__